import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { InputMaskModule } from 'primeng/inputmask';
import { SidebarComponent } from '../components/sidebar/sidebar.component';
import { HeaderComponent } from '../components/header/header.component';
import { SubheaderComponent } from '../components/subheader/subheader.component';
import { CustomValidators } from '../shared/validators/custom-validators';

@Component({
  selector: 'app-second-personal-reference',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    ButtonModule,
    InputMaskModule,
    SidebarComponent,
    HeaderComponent,
    SubheaderComponent
  ],
  templateUrl: './second-personal-reference.component.html',
  styleUrl: './second-personal-reference.component.css'
})
export class SecondPersonalReferenceComponent implements OnInit {
  personalReferenceForm!: FormGroup;
  colonyOptions: any[] = [];
  municipalityOptions: any[] = [];

  constructor(private router: Router, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    this.personalReferenceForm = this.fb.group({
      cellPhone: ['', [Validators.required, CustomValidators.mexicanPhone]],
      names: ['', [Validators.required, Validators.minLength(2)]],
      lastNameP: ['', [Validators.required, Validators.minLength(2)]],
      lastNameM: ['', [Validators.required, Validators.minLength(2)]],
      relation: [null, Validators.required],
      yearsKnown: [null, Validators.required],
      phone: ['', CustomValidators.mexicanPhone],
      contactSchedule: ['', Validators.required],
      address: this.fb.group({
        street: ['', Validators.required],
        extNumber: ['', Validators.required],
        intNumber: [''],
        postalCode: ['', [Validators.required, CustomValidators.postalCode]],
        neighborhood: [null, Validators.required],
        municipality: [null, Validators.required],
        state: ['', Validators.required],
        housingType: [null, Validators.required],
        yearsResidence: [null, [Validators.required, Validators.min(1)]]
      })
    });

    // Inicializar opciones
    this.colonyOptions = [
      { label: 'Colonia 1', value: 'col1' },
      { label: 'Colonia 2', value: 'col2' }
    ];

    this.municipalityOptions = [
      { label: 'Delegación/Municipio 1', value: 'mun1' },
      { label: 'Delegación/Municipio 2', value: 'mun2' }
    ];
  }

  relationOptions = [
    { label: 'Amigo(a)', value: 'friend' },
    { label: 'Familiar', value: 'family' },
    { label: 'Compañero(a) de trabajo', value: 'coworker' },
    { label: 'Vecino(a)', value: 'neighbor' },
    { label: 'Otro', value: 'other' }
  ];

  yearsKnownOptions = [
    { label: '1 año', value: 1 },
    { label: '2 años', value: 2 },
    { label: '3 años', value: 3 },
    { label: '4 años', value: 4 },
    { label: '5 años', value: 5 },
    { label: 'Más de 5 años', value: 6 }
  ];

  housingTypeOptions = [
    { label: 'Casa propia', value: 'own' },
    { label: 'Rentada', value: 'rent' },
    { label: 'Con familiares', value: 'family' },
    { label: 'Otro', value: 'other' }
  ];

  onPostalCodeChange(): void {
    const postalCode = this.personalReferenceForm.get('address.postalCode')?.value;
    if (postalCode && postalCode.length === 5) {
      // Simular carga de colonias y municipios basado en código postal
      this.loadColoniesAndMunicipalities(postalCode);
    }
  }

  loadColoniesAndMunicipalities(postalCode: string): void {
    // Simular llamada a API
    this.colonyOptions = [
      { label: `Colonia ${postalCode}-1`, value: `col_${postalCode}_1` },
      { label: `Colonia ${postalCode}-2`, value: `col_${postalCode}_2` }
    ];

    this.municipalityOptions = [
      { label: `Municipio ${postalCode}`, value: `mun_${postalCode}` }
    ];
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.personalReferenceForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  getFieldError(fieldName: string): string {
    const field = this.personalReferenceForm.get(fieldName);
    if (field && field.errors && (field.dirty || field.touched)) {
      if (field.errors['required']) return 'Este campo es requerido';
      if (field.errors['minLength']) return `Mínimo ${field.errors['minLength'].requiredLength} caracteres`;
      if (field.errors['mexicanPhone']) return 'Formato de teléfono inválido';
      if (field.errors['postalCode']) return 'Código postal inválido';
      if (field.errors['min']) return `Valor mínimo: ${field.errors['min'].min}`;
    }
    return '';
  }

  markAllFieldsAsTouched(): void {
    this.personalReferenceForm.markAllAsTouched();
  }

  goBack(): void {
    this.router.navigate(['/first-reference']);
  }

  onSubmit(): void {
    if (this.personalReferenceForm.valid) {
      console.log('Segunda referencia personal enviada:', this.personalReferenceForm.value);
      this.router.navigate(['/additional-data']);
    } else {
      this.markAllFieldsAsTouched();
      console.log('Formulario inválido');
    }
  }
}
